/**
 * 接口基本配置
 */

const mock = false
let baseURL = '' // 接口地址

if (mock) {
  baseURL = '/m1/3280155-0-default/'
} else {
  // console.log(process.env)
  if (process.env.NODE_ENV == 'development') {
    baseURL = 'http://192.168.110.139:9091/dsejg'
  } else if (process.env.NODE_ENV == 'production') {
    baseURL = 'https://api-prod.hfasdre.com/dsejg'
  } else if (process.env.NODE_ENV == 'mytest') {
    baseURL = 'http://192.168.110.124:9091/dsejg'
  } else if (process.env.NODE_ENV == 'uat') {
    baseURL = 'https://api-uat.hfasdre.com/dsejg'
  }
}

export default baseURL
